import styles from "./Badge.module.css";

/** tone: neutral | success | warning | danger | info | honey. size: "lg" for a badge that sits beside a heading. */
export function Badge({ tone = "neutral", size, children, className = "" }) {
  return <span className={[styles.badge, styles[tone], size === "lg" ? styles.lg : "", className].filter(Boolean).join(" ")}>{children}</span>;
}
